import { FormControl, FormLabel, Input, Select, Text } from '@chakra-ui/react'
import { useCallback } from 'react'
import { Profile } from '../../../../../types/FirestoreUser'
import { relationshipOptions } from '../constants/relationshipOptions'
import PhoneNumberInput from './PhoneNumberInput'

interface EmergencyContactSectionProps {
  profile: Profile
  extraInfoRequired: boolean
  onUpdate: (changes: Partial<Profile>) => void
}

const EmergencyContactSection = ({
  profile,
  extraInfoRequired,
  onUpdate,
}: EmergencyContactSectionProps) => {
  const handleEmergencyPhoneUpdate = useCallback(
    (changes: { phoneNumber?: string; phoneCountryCode?: string }) => {
      const updates: Partial<Profile> = {}
      if (changes.phoneNumber !== undefined) {
        updates.emergencyContactPhone = changes.phoneNumber
      }
      if (changes.phoneCountryCode !== undefined) {
        updates.emergencyContactPhoneCountryCode = changes.phoneCountryCode
      }
      onUpdate(updates)
    },
    [onUpdate]
  )

  return (
    <>
      <FormControl>
        <FormLabel>
          Emergency Contact First Name{' '}
          {extraInfoRequired && (
            <Text as='span' color='red.500'>
              *
            </Text>
          )}
        </FormLabel>
        <Input
          required={extraInfoRequired}
          defaultValue={profile.emergencyContactFirstName || ''}
          onChange={(e) =>
            onUpdate({ emergencyContactFirstName: e.target.value })
          }
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          Emergency Contact Last Name{' '}
          {extraInfoRequired && (
            <Text as='span' color='red.500'>
              *
            </Text>
          )}
        </FormLabel>
        <Input
          required={extraInfoRequired}
          defaultValue={profile.emergencyContactLastName || ''}
          onChange={(e) =>
            onUpdate({ emergencyContactLastName: e.target.value })
          }
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          Emergency Contact Relationship{' '}
          {extraInfoRequired && (
            <Text as='span' color='red.500'>
              *
            </Text>
          )}
        </FormLabel>
        <Select
          required={extraInfoRequired}
          placeholder='Choose Relationship'
          defaultValue={profile.emergencyContactRelationship || ''}
          onChange={(e) =>
            onUpdate({ emergencyContactRelationship: e.target.value })
          }
        >
          {relationshipOptions.map((opt) => (
            <option value={opt.value} key={opt.value}>
              {opt.label}
            </option>
          ))}
        </Select>

        {profile.emergencyContactRelationship === 'other' && (
          <FormControl mt={2}>
            <FormLabel>Specify Relationship</FormLabel>
            <Input
              value={profile.emergencyContactRelationshipOther || ''}
              onChange={(e) =>
                onUpdate({ emergencyContactRelationshipOther: e.target.value })
              }
            />
          </FormControl>
        )}
      </FormControl>

      <FormControl>
        <FormLabel>
          Emergency Contact Email{' '}
          {extraInfoRequired && (
            <Text as='span' color='red.500'>
              *
            </Text>
          )}
        </FormLabel>
        <Input
          required={extraInfoRequired}
          type='email'
          defaultValue={profile.emergencyContactEmail || ''}
          onChange={(e) => onUpdate({ emergencyContactEmail: e.target.value })}
        />
      </FormControl>

      <PhoneNumberInput
        phoneNumber={profile.emergencyContactPhone || ''}
        phoneCountryCode={profile.emergencyContactPhoneCountryCode}
        addressCountry={profile.country}
        isRequired={extraInfoRequired}
        label='Emergency Contact Phone'
        onUpdate={handleEmergencyPhoneUpdate}
      />
    </>
  )
}

export default EmergencyContactSection
